export const initialise = () => {
    siteSwitcher()
}

const siteSwitcher = () => {
    const header = document.querySelector<HTMLElement>('header.header')
    if (!header) return
    const siteSwitcher = header.querySelector<HTMLDivElement>('.header__site-switcher')
    const button = header.querySelector<HTMLButtonElement>('.header__site-switcher-button')
    const dropdown = header.querySelector<HTMLDivElement>('.header__site-switcher-dropdown')

    if (!siteSwitcher || !button || !dropdown) return

    const closeDropdown = () => {
        dropdown.setAttribute('aria-hidden', 'true')
        button.setAttribute('aria-expanded', 'false')
        document.removeEventListener('click', clickAway)
        document.removeEventListener('keyup', tabAway)
    }

    const clickAway = (event: Event) => {
        const target = event.target as HTMLElement
        if (!siteSwitcher.contains(target)) { 
            closeDropdown()
        }
    }

    const tabAway = (event: KeyboardEvent) => {
        if (event.key !== 'Tab') return
        const target = event.target as HTMLElement
        if (!siteSwitcher.contains(target)) {
            closeDropdown()
        }
    }

    button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true'
        button.setAttribute('aria-expanded', (!isExpanded).toString())
        dropdown.setAttribute('aria-hidden', isExpanded.toString())

        const firstLink = dropdown.querySelector<HTMLAnchorElement>('a')
        setTimeout(() => {
            firstLink?.focus()
        }, 100) 

        document.addEventListener('click', clickAway)
        document.addEventListener('keyup', tabAway)
    })
}